import LibrarySourcesPage from '@pages/team/[teamId]/library/sources';
import LibrarySourceDetailsPage from '@pages/team/[teamId]/library/sources/:sourceId';
import TeamSourcePreviewPage from '@pages/team/[teamId]/library/sources/:sourceId/preview';

export const libraryRoutes = {
  path: 'library',
  children: [
    {
      path: 'sources',
      children: [
        { path: '', element: <LibrarySourcesPage /> },
        {
          path: ':sourceId',
          children: [
            { path: '', element: <LibrarySourceDetailsPage /> },
            { path: 'preview', element: <TeamSourcePreviewPage /> },
          ],
        },
      ],
    },
  ],
};
